import React, { useState } from "react";
import {
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    ButtonToolbar,
    Button,
    SelectPicker,
    Schema,
    Notification,
    Icon,
} from "rsuite";
import bg_login from "../../assets/imgs/bglogin.png";
import { accountService } from "../../services/account.service";
import environmentsEs from "../../data/environmentsEs.json";
import environmentsEn from "../../data/environmentsEn.json";
import { useTranslation } from 'react-i18next';
import "./login.scss";

export function Login(props) {
    const { StringType } = Schema.Types;

    const { t, i18n } = useTranslation();
    const model = Schema.Model({
        UserName: StringType().isRequired(t('login.fieldRequired')),
        Password: StringType().isRequired(t('login.fieldRequired')),
        Environment: StringType().isRequired(t('login.fieldRequired')),
    });

    const [formValue, setFormValue] = useState({});

    const handleSubmit = (formStatus) => {
        if (formStatus) {
            accountService.login(formValue).then((result) => {
                if (result) {
                    props.history.push("/business");
                } else {
                    Notification.error({
                        title: `${t('login.invalidLogin')}`,
                        duration: 5000,
                    });
                }
            });
        }
    };

    const [showPass, setShowPass] = useState("password");
    const [activePass, setActivePass] = useState('eye-slash')


    const iconPass = () => {
        setShowPass(showPass === "password" ? "text" : "password");
        setActivePass(activePass === "eye-slash" ? "eye" : "eye-slash");
    };

    return (
        <div className="wrapper_login ">
            <div className="am_container">
                <Form
                    onChange={(formValue) => setFormValue(formValue)}
                    model={model}
                    onSubmit={handleSubmit}
                    fluid
                    className="box_form"
                >
                    <div className="text-center mb-5">
                        <h3 className="mb-1 c_primary fw-700">{t('login.welcome')}</h3>
                        <h5 className="fw-300">{t('login.readyToHelp')}</h5>
                    </div>
                    <FormGroup>
                        <ControlLabel>{t('login.username')}</ControlLabel>
                        <FormControl name="UserName" type="text" size="lg" />
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>{t('login.password')}</ControlLabel>
                        <span className="inputIcon">
                            <FormControl name="Password" type={showPass} size="lg" />
                            <span className="icoPass" onClick={iconPass}>
                                <Icon icon={activePass} size="lg" />
                            </span>
                        </span>
                    </FormGroup>
                    <FormGroup className="mb-1">
                        <ControlLabel>{t('login.sessionMode')}</ControlLabel>
                        <FormControl
                            accepter={SelectPicker}
                            block
                            size="lg"
                            name="Environment"
                            data={i18n.language === 'en' ? environmentsEn : environmentsEs}
                            searchable={false}
                            placeholder={t('login.choose')}
                        />
                    </FormGroup>
                    <FormGroup className="mt-5">
                        <ButtonToolbar>
                            <Button
                                className="btn primary"
                                block
                                appearance="primary"
                                size="lg"
                                type="submit"
                            >
                                {t('login.login')}
                            </Button>
                        </ButtonToolbar>
                    </FormGroup>
                </Form>
                <img
                    className="bg_img_login"
                    src={bg_login}
                    alt="Red Pay MX, Pagos online, visa, mastercard, oxxo pay"
                />
            </div>
        </div>
    );
}
